import React, { FC } from 'react'
import { Icon, IconProps } from '@chakra-ui/react'
import { defineDirection, Direction } from './definitions'

type FilledArrowProps = IconProps & {
  direction?: Direction
}

const FilledArrow: FC<FilledArrowProps> = ({
  direction = Direction.Left,
  ...chakraProps
}) => (
  <Icon
    transform={defineDirection(direction)}
    viewBox="0 0 24 24"
    // ChakraUIs type definitions clash apparently.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(chakraProps as any)}>
    <path
      d="M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z"
      fill="currentColor"
    />
  </Icon>
)

// eslint-disable-next-line functional/immutable-data
FilledArrow.displayName = 'FilledArrow'

export { FilledArrow }
